module.exports = __webpack_public_path__ + "static/media/login-ill1.5081795e.svg";